/* eslint-disable */
import webchat from '@/services/websocket/actionsFromWebchat'

/**
 * Executes actions the webchatMessages service.
 * @param {string} channel
 * @param {string} action
 * @param {object} data
 */
export const execute = (channel: string, action: string, data: any) => {
  if (action === 'ping') {
    ping()
    return
  }

  switch (channel) {
    case 'webchat':
      webchatExecute(action, data)
  }
}

const webchatExecute = (action: string, data: any) => {
  switch (action) {
    case 'received_messages':
      return webchat.receiveMessages(data)
  }
}

const ping = () => {
  console.log('ping') // TODO: Implement PONG
}
